import CrossIconPath from "@ingka/ssr-icon/paths/cross";

export default CrossIconPath;
